export default "__VITE_ASSET___J0JjuPV__"